export enum SystemMessageCodes {
    QR_SCANNED_SUCCESSFULLY = 'QR_SCANNED_SUCCESSFULLY'
}
